import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../services/filtering/filter-form-render-service';
import messages from '../messages';

export default {
  id: 'productType',
  displayName: <FormattedMessage {...messages.productTypeColumnHeader} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ProductType',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
};
